export class SectorModel {

    SectorName: string;
    ModelName: string;
    User: string;
}
export class ExcelPredictModel {
  sectorModel: SectorModel;
  IsContraEnabled: boolean;
}
export class sectors {  
    Id: number;
    SectorName: string;
    Description: string;  
}

export class models {
    Id: number;
    SectorName: string;
    ModelName: string;
    Description: string;
    ThresholdProbability: any;

}
export class labels {
    Id: number;
    SectorName: string;
    LabelName: string;
    Labeltype: string;
    IsNull: boolean;

}

export class users {
    Id: number;
    UserName: string;
    SectorNames: string;
    IsAdmin: boolean;
    Password: string;
    Roleid: string;
    samAccountName: string;
}
export class UserviewModel {
    User: users;
    SectorList: string[];
}
